import type { ReactNode } from 'react';

import { HStack } from '../primitives/Stack.js';
import { Text } from '../primitives/Text.js';
import { cx } from '../primitives/cx.js';
import { Icon } from './Icon.js';
import type { IconName } from './Icon.js';

export type ChipTone = 'neutral' | 'accent' | 'gold' | 'flame' | 'danger';

const toneClass: Record<ChipTone, string> = {
  neutral: 'bg-sunken text-muted border-line',
  accent: 'bg-accent-soft text-accent border-transparent',
  gold: 'bg-gold-soft text-gold border-transparent',
  flame: 'bg-flame-soft text-flame border-transparent',
  danger: 'bg-danger-soft text-danger border-transparent',
};

export type ChipProps = {
  tone?: ChipTone;
  icon?: IconName;
  children?: ReactNode;
  className?: string;
};

/** Generic pill. Titles, tags, filters and status all render through this. */
export function Chip({ tone = 'neutral', icon, children, className }: ChipProps) {
  return (
    <HStack
      gap={1}
      align="center"
      className={cx('rounded-full border px-2.5 py-1', toneClass[tone], className)}
    >
      {icon && <Icon name={icon} size={13} />}
      <Text variant="caption" className="text-current" tone="ink">
        {children}
      </Text>
    </HStack>
  );
}
